module.exports = __webpack_public_path__ + "img/owl.956b0c67.svg";